const FormResources = {

    form_data:{
        name:           '',
        roles_id:       [],
    },

    form_format:
    [
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Reports to:',
            model_name: 'roles_id',
            ref:        'roles_id_input',
            ref_alt:    'roles_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select role(s)',
            close_on_option: false,
            track_by: 'name'
        },
    ]

}

export default FormResources;